import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {ModeratAnfrage} from "../anfrage/moderat.anfrage";
import {FinanzierungsTyp, ResultData} from "../interfaces/result-data.interface";

/**
 * Component to show the economy table
 */
@Component({
    selector: 'app-moderat-sanierung-economy',
    templateUrl: './sanierung-economy.component.html',
    standalone: false
})
export class SanierungEconomyComponent implements OnInit, OnChanges {
  /**
   * the request object
   */
  @Input() anfrage: ModeratAnfrage;

  /**
   * current financing type
   */
  @Input() financing: FinanzierungsTyp;

  /**
   * loading indicator
   */
  @Input() loading: boolean;

  /**
   * result to show in the table
   */
  measureResult: ResultData;

  /**
   * true if pv and wp are selected or already existing in input data
   */
  hasPvAndWP: boolean;
  /**
   * list of toggles for help texts
   */
  toggle = {
    investitionskosten_jahr: false,
    energiekosten_jahr: false,
    co2_kosten_jahr: false
  };

  /**
   * text key prefix
   */
  textkeyPrefix = 'moderat.sanierung.wirtschaftlichkeit.';

  /**
   * text key postfix for the hints
   */
  textkeyPostfixHint = ''

  /**
   * @inheritDoc
   */
  ngOnInit(): void {
    this.updateMeasures();
    this.checkExistingAndSelectedMeasures();
    this.initTextkeyPostfixHint();
  }

  /**
   * @inheritDoc
   */
  ngOnChanges(changes: SimpleChanges): void {
    if(changes.loading && changes.loading.currentValue === false) {
      this.updateMeasures();
      this.checkExistingAndSelectedMeasures();
    }
  }

  /**
   * update costs from result.
   */
  updateMeasures(): void {
    if(this.anfrage?.measureResult) {
      this.measureResult = this.anfrage.measureResult;
    }
  }

  /**
   * check if some measures are selected or already existing in input data
   */
  checkExistingAndSelectedMeasures(): void {
    this.hasPvAndWP = false;

    // init wp values
    let selectedWP = false;
    const existingWP = this.anfrage?.verbrauchsanalyseInput?.energietraeger_name?.startsWith('waermepumpe');

    // check if wp is selected as measure on result page
    Object.keys(this.measureResult?.measures).filter(key => key.startsWith('waermepumpe')).forEach(key => {
      if (this.measureResult.measures[key] && typeof this.measureResult.measures[key] === 'object' && this.measureResult.measures[key].selected === true) {
        selectedWP = true;
      }
    });

    const hasWP = existingWP || selectedWP;
    const hasPV = this.anfrage?.bestandsanalyseInput?.photovoltaik_vorhanden === "ja" || this.measureResult.measures.photovoltaik.selected === true;

    // set to true if pv and wp are selected or already existing in input data
    this.hasPvAndWP = hasPV && hasWP;

    // init the text key postfix hint after changes in the input data / selected measures
    this.initTextkeyPostfixHint();
  }

  /**
   * Initializes the text key postfix hint based on input data and/or selected measures.
   */
  initTextkeyPostfixHint(): void {
    // default value is empty string
    this.textkeyPostfixHint = '';

    // case: additional heating
    if (this.anfrage?.verbrauchsanalyseInput?.zusatzheizung_vorhanden === "ja" && this.anfrage?.verbrauchsanalyseInput?.zusatzheizung_verbrauch > 0) {
      this.textkeyPostfixHint = 'zusatzheizung.';

      // case: additional heating and pv + wp
      if (this.hasPvAndWP) {
        this.textkeyPostfixHint = 'zusatzheizung.pv.';
      }
    }
    // case pv and wp
    else if (this.hasPvAndWP) {
      this.textkeyPostfixHint = 'pv.';
    }
  }
}
